import { Formik } from "formik";
import InputField from "../../../../atoms/InputField";
import TemplateForm from "../../../../atoms/TemplateForm";
import moment from "moment";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { UPDATE_QUEJA } from "../../../../../api/apiQuejas";
import { useSession } from "../../../../../context/SessionContext";

const EditQYR = ({ QOR, refetch, onClose }) => {
    const { user } = useSession();

    const handleSubmit = async (values, { setIsSubmitting }) => {
        try {
            const newValues = { service_date:moment().format("YYYY-MM-DD HH:mm"), staffId: user?.id, ...values };
            await UPDATE_QUEJA(QOR.id, newValues);
            toast.success("Resuelto correctamente, se notificara a los responsables");
            refetch();
            onClose();
        } catch (error) {
            console.error(error);
            toast.error("Error al crear intente más tarde");
        } finally {
            setIsSubmitting(false);
        }
    };

    const initialValues = {
        service_date: moment().format("YYYY-MM-DD"),
        comment_admin: "",
        status: "Resuelto",
    };

    const validationSchema = Yup.object({
        comment_admin: Yup.string()
            .max(255, "Máximo 255 caracteres")
            .required("Este campo es requerido"),
    });

    return (
        <div>
            <div className="text-xl flex flex-col gap-2">
                <strong> {QOR?.description} </strong>
                <p> {QOR?.comment_user} </p>
            </div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ isSubmitting }) => (
                    <TemplateForm
                        fields={
                            <>
                                <InputField name="service_date" label="Fecha de resolución" type="date" disabled placeholder={moment().format("YYYY-MM-DD")}/>
                                <div className="w-full col-span-2">
                                    <InputField name="comment_admin" label="Comentarios" type="textarea" />
                                </div>
                            </>
                        }
                        isSubmitting={isSubmitting}
                        textButton="Aceptar"
                        />
                    )}
            </Formik>
        </div>
    );
};

export default EditQYR;